/* seib-bags-card-color-thumbnails-20260731-start */
(() => {
  if (!location.pathname.includes('/collections/bages-packs')) return;
  const waistHandle = 'seibertron-tactical-military-waterproof-outdoor-7-9-tablet-shoulder-waist-bag-leisure-wallet-everyday-bag';
  const edcHandle = 'seibertron-compact-edc-pouch-utility-gadget-wallet-fit-6-3-phone-belt-bag';
  const waistImages = {
    black: '/cdn/shop/products/Seibertron-tactical-Military-Waterproof-outdoor-7-9-tablet-shoulder-waist-bag-Leisure-wallet-Everyday-Bag-Seibertron-24009096265918.jpg?v=1769483100',
    khaki: '/cdn/shop/products/Seibertron-tactical-Military-Waterproof-outdoor-7-9-tablet-shoulder-waist-bag-Leisure-wallet-Everyday-Bag-Seibertron-24114728566974.jpg?v=1769483100'
  };
  const edcImages = {
    black: '/cdn/shop/files/Seibertron-Compact-EDC-Pouch-Utility-Gadget-Wallet-Fit-6-3-Phone-Belt-Bag-Seibertron-29093794152638.jpg?v=1769483286',
    khaki: '/cdn/shop/files/Seibertron-Compact-EDC-Pouch-Utility-Gadget-Wallet-Fit-6-3-Phone-Belt-Bag-Seibertron-29093794185406.jpg?v=1769483286'
  };

  function articleFor(handle) {
    return document.querySelector('a[href*="/products/' + handle + '"]')?.closest('article');
  }

  function setThumb(thumb, handle, variantId, imageUrl) {
    if (!thumb) return;
    const href = '/collections/bages-packs/products/' + handle + '?variant=' + variantId;
    if (thumb.getAttribute('href') !== href) thumb.setAttribute('href', href);
    const image = thumb.querySelector('img');
    if (!image) return;
    const src = imageUrl + '&width=96';
    const srcset = imageUrl + '&width=48 48w, ' + imageUrl + '&width=72 72w, ' + imageUrl + '&width=96 96w';
    if (image.getAttribute('src') !== src) image.setAttribute('src', src);
    if (image.getAttribute('srcset') !== srcset) image.setAttribute('srcset', srcset);
  }

  function apply() {
    const waist = articleFor(waistHandle);
    if (waist) {
      for (const thumb of waist.querySelectorAll('.seib-product-card__color-thumb')) {
        const title = (thumb.getAttribute('title') || '').toLowerCase();
        if (title.includes('black')) setThumb(thumb, waistHandle, '41897924362430', waistImages.black);
        if (title.includes('khaki')) setThumb(thumb, waistHandle, '41897924395198', waistImages.khaki);
      }
    }
    const edc = articleFor(edcHandle);
    if (edc) {
      for (const thumb of [...edc.querySelectorAll('.seib-product-card__color-thumb')]) {
        const title = (thumb.getAttribute('title') || '').toLowerCase();
        if (title.includes('arm bag')) {
          thumb.remove();
        } else if (title === 'black') {
          setThumb(thumb, edcHandle, '41897896280254', edcImages.black);
        } else if (title === 'khaki') {
          setThumb(thumb, edcHandle, '41897896313022', edcImages.khaki);
        }
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
  else apply();
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      apply();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
/* seib-bags-card-color-thumbnails-20260731-end */
